import React from 'react';
import Styled from 'styled-components';
import logoImg from '~/images/logo_white.png';
import backgroundImg from '~/images/bg_02.png';
// import NavMenu from '../NavMenu';
import MenuLink from '~/components/MenuLink';
import MenuMobile from '~/components/MenuMobile';

const HeaderBlock = Styled.div`
  padding: 10px 0px;
  background: url(${backgroundImg});
`;

const ImgStyled = Styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const LayoutHeader = (props) => (
  <section>
    <HeaderBlock>
      <div className="container">
        <MenuMobile {...props} />
        <div className="row">
          <div className="col-md-12">
            <ImgStyled src={logoImg} alt="" />
          </div>
        </div>
        <MenuLink {...props} />
      </div>
    </HeaderBlock>
  </section>
);

export default LayoutHeader;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/LayoutHeader.js